// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { Project } from '@/project/api/types';
import { getInterval } from '@/project/utilities/get-interval';
import { Typography, TypographyProps } from '@mui/material';

const DEFAULT_FORMAT_OPTIONS: Intl.DateTimeFormatOptions = {
  dateStyle: 'medium',
};

interface Props extends Pick<TypographyProps, 'variant' | 'whiteSpace'> {
  project: Pick<Project, 'startOn' | 'endOn' | 'isArchived'>;
  formatOptions?: Intl.DateTimeFormatOptions;
}

export function ProjectDateRangeLabel(props: Props) {
  const interval = getInterval(props.project);
  const formatOptions = props.formatOptions ?? DEFAULT_FORMAT_OPTIONS;

  if (interval) {
    const color = props.project.isArchived ? 'text.disabled' : 'text.primary';

    return (
      <Typography
        color={color}
        variant={props.variant}
        whiteSpace={props.whiteSpace}
      >
        {interval.toLocaleString(formatOptions)}
      </Typography>
    );
  }

  if (props.project.startOn) {
    const color = props.project.isArchived ? 'text.disabled' : 'text.primary';

    return (
      <Typography
        color={color}
        variant={props.variant}
        whiteSpace={props.whiteSpace}
      >
        {props.project.startOn.toLocaleString(formatOptions)}
      </Typography>
    );
  }

  if (props.project.endOn) {
    const color = props.project.isArchived ? 'text.disabled' : 'text.primary';

    return (
      <Typography
        color={color}
        variant={props.variant}
        whiteSpace={props.whiteSpace}
      >
        {props.project.endOn.toLocaleString(formatOptions)}
      </Typography>
    );
  }

  const color = props.project.isArchived ? 'text.disabled' : 'text.secondary';

  return (
    <Typography
      color={color}
      variant={props.variant}
      whiteSpace={props.whiteSpace}
    >
      Not set
    </Typography>
  );
}
